import storefront from '@/lib/storefront';
import * as queries from '@/lib/queries';

export const SIZE_GUIDE_SECTION_ID = 'template--page-size-guide__size_guide';

const escapeHtml = value =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const themeRootUrl = () => window.theme?.routes?.root_url || '/';

const fetchHtml = async url => {
  const fetchFn = window.theme?.fetchWithRetry || window.fetch;
  const response = await fetchFn.call(window, url);
  if (!response?.ok) {
    return '';
  }
  return response.text();
};

const isDataTableHtml = html => /data-section-type=["']data-table["']/i.test(html || '');

const extractDataTableSection = html => {
  if (typeof DOMParser === 'undefined' || !html) {
    return '';
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const node = doc.querySelector('[data-section-type="data-table"]');
  return node ? node.outerHTML : '';
};

const wrapSectionHtml = (title, sectionHtml) => ({
  title,
  content: `<div class="size-guide-modal-content"><div class="section-padding" style="--PT: 50px; --PB: 0;"><div class="wrapper"><h1 class="gt-h1">${escapeHtml(title)}</h1></div></div>${sectionHtml}</div>`
});

const wrapLegacyBody = (title, body) => ({
  title,
  content: `
            <section class="section-padding" style="--PT: 50px; --PB: 36px;">
              <div class="wrapper">
                <div class="text__standard text-left">
                  <h1 class="gt-h1">
                    ${escapeHtml(title)}
                  </h1>
                  <div class="rte gt-p">
                    ${body || ''}
                  </div>
                </div>
              </div>
            </section>
          `
});

export async function fetchSizeGuidePageContent(pageId) {
  if (!pageId) {
    return null;
  }

  try {
    const response = await storefront.request(queries.getOnlineStorePageById, {
      variables: {
        id: `gid://shopify/Page/${pageId}`
      }
    });
    const page = response?.data?.page;
    if (!page) {
      return null;
    }

    const handle = page.handle;
    if (handle) {
      const root = themeRootUrl();
      const sectionHtml = await fetchHtml(`${root}pages/${handle}?section_id=${SIZE_GUIDE_SECTION_ID}`);
      if (isDataTableHtml(sectionHtml)) {
        return wrapSectionHtml(page.title, sectionHtml);
      }

      const viewHtml = await fetchHtml(`${root}pages/${handle}?view=size-guide`);
      const fromView = extractDataTableSection(viewHtml);
      if (isDataTableHtml(fromView)) {
        return wrapSectionHtml(page.title, fromView);
      }

      const fullHtml = await fetchHtml(`${root}pages/${handle}`);
      const extracted = extractDataTableSection(fullHtml);
      if (isDataTableHtml(extracted)) {
        return wrapSectionHtml(page.title, extracted);
      }
    }

    return wrapLegacyBody(page.title, page.body);
  } catch (error) {
    console.error('Error loading size guide content', error);
    return null;
  }
}
